import React from "react";
import { OfflineSystemTemplate } from "../../Templates/OfflineSystemTemplate";

export const OfflineSystem = () => {
  return <OfflineSystemTemplate />;
};
